import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { SubpageLayout } from '../components/SubpageLayout';
import { imprintRows, legalPages } from '../data/legal';

/** One template for all legal subpages: Imprint, Privacy Policy, Terms of Use, Cookie Policy. */
export function Legal() {
  const {
    slug
  } = useParams();
  const page = legalPages.find(p => p.slug === slug);
  if (!page) return <Navigate to="/legal/imprint" replace data-id="element-532" data-mp="a1eyisuocv1i" />;
  return <SubpageLayout title={page.title} data-id="element-533" data-mp="9zvk77skwu2d">
      <div className="px-page pb-20 pt-36 md:pb-28 md:pt-44" data-id="element-534" data-mp="esonrscb9wcv">
        <div className="grid gap-12 md:grid-cols-12 md:gap-x-6" data-id="element-535" data-mp="eu87xu138rjx">
          {/* Left: title + legal navigation */}
          <aside className="md:col-span-4" data-id="element-536" data-mp="52c5y7vvshaf">
            <p className="text-[12px] font-medium uppercase tracking-[0.04em] text-fg/60" data-id="element-537" data-mp="53dfg7x90vq1">Legal</p>
            <h1 className="mt-4 font-serif text-[36px] font-normal leading-[1.08] tracking-[-0.01em] md:text-[48px]" data-id="element-538" data-mp="3n9jjmnuoyghg">
              {page.title}
            </h1>
            <p className="mt-3 text-[13px] text-fg/45" data-id="element-539" data-mp="27kljklpnfmhj">Last updated {page.updated}</p>

            <nav aria-label="Legal pages" className="mt-10 md:sticky md:top-28" data-id="element-540" data-mp="23jtabsgs1hl9">
              <ul className="border-t border-line" data-id="element-541" data-mp="23lvwu2iq0sl8">
                {legalPages.map(p => {
                const active = p.slug === page.slug;
                return <li key={p.slug} className="border-b border-line" data-id="element-542" data-mp="2cl0ul6mgkhwc">
                      <Link to={`/legal/${p.slug}`} aria-current={active ? 'page' : undefined} className={`block py-3 text-[15px] transition-colors duration-150 ${active ? 'text-fg' : 'text-fg/45 hover:text-fg'}`} data-id="element-543" data-mp="1ovooifmfgpy9">
                        {p.title}
                      </Link>
                    </li>;
              })}
              </ul>
            </nav>
          </aside>

          {/* Right: content */}
          <article className="md:col-span-7 md:col-start-6" data-id="element-544" data-mp="317k8eiac93p9">
            {page.slug === 'imprint' && <dl className="mb-14 border-t border-line" data-id="element-545" data-mp="365vd6els0o0m">
                {imprintRows.map(row => <div key={row.label} className="grid gap-1 border-b border-line py-4 md:grid-cols-[220px_1fr] md:gap-6" data-id="element-546" data-mp="3awvavm2pza46">
                    <dt className="text-[13px] text-fg/45" data-id="element-547" data-mp="3exf9yv6usnsy">{row.label}</dt>
                    <dd className="text-[16px] leading-[1.45] text-fg" data-id="element-548" data-mp="2i97vqmk7xbox">
                      {row.href ? <a href={row.href} className="underline decoration-fg/30 underline-offset-4 transition-colors duration-150 hover:decoration-fg" data-id="element-549" data-mp="2n8kf2xbvs0mr">
                          {row.value}
                        </a> : row.value}
                    </dd>
                  </div>)}
              </dl>}

            <div className="space-y-10" data-id="element-550" data-mp="lmgfsnbyfvbm">
              {page.sections.map(s => <section key={s.heading} data-id="element-551" data-mp="gn3tq4swqsa3">
                  <h2 className="text-[19px] leading-[1.3] tracking-[-0.01em] text-fg md:text-[20px]" data-id="element-552" data-mp="go540723naqr">{s.heading}</h2>
                  <div className="mt-3 max-w-[640px] space-y-4 text-[15px] leading-[1.6] text-fg/60" data-id="element-553" data-mp="buaq5k96dpzl">
                    {s.body.split('\n\n').map((para, i) => <p key={i} data-id="element-554" data-mp="2wgumbj8j0dh" data-mpi={i}>{para}</p>)}
                  </div>
                </section>)}
            </div>
          </article>
        </div>
      </div>
    </SubpageLayout>;
}